// extracted by mini-css-extract-plugin
export default {"tabHome":"TabHome_tabHome__rLfdB","backIcon":"TabHome_backIcon__bZ3os","mshopLogo":"TabHome_mshopLogo__-w47M"};